/**
 * Centralized utility for role + plan-based permissions
 * Updated for user.role.permissionGroups structure
 */

// Role-based: Check if user has a specific permission
export function hasPermission(user, responsibilityName, actionName) {
  if (!user || !user.role || !user.role.permissionGroups) return false;
  if (user.role.name === "SuperAdmin") return true;

  const responsibility = responsibilityName?.toLowerCase();
  const actions = Array.isArray(actionName)
    ? actionName.map(a => a?.toLowerCase())
    : actionName ? [actionName?.toLowerCase()] : [];

  return user.role.permissionGroups.some(group =>

    group.permissions?.some(permission =>
      permission.permission?.name?.toLowerCase() === responsibility &&
      permission.allowedActions?.some(
        action =>
          actions.includes(action.name?.toLowerCase())
      )
    )
  );
}

// Role-based: Check if user has a responsibility (ignoring actions)
export function hasResponsibility(user, responsibilityName) {
  if (!user || !user.role || !user.role.permissionGroups) return false;
  if (user.role.name === "SuperAdmin") return true;
  console.log('user.role.permissionGroups',user.role.permissionGroups);
  return user.role.permissionGroups.some(group =>
    group.permissions?.some(permission =>
      permission.permission?.name?.toLowerCase() === responsibilityName?.toLowerCase()
    )
  );
}

// Plan-based: Check plan responsibility
export function hasPlanResponsibility(responsibilityName) {
  try {
    const planResponsibilities =
      JSON.parse(localStorage.getItem("planResponsibilities")) || [];
    return planResponsibilities.some(
      r => r && r.toLowerCase() === responsibilityName.toLowerCase()
    );
  } catch {
    return false;
  }
}

// Unified: Plan OR Role
export function hasAccess(user, responsibilityName, actionName = null) {
  if (user?.role?.name === "SuperAdmin") return true;
  // Plan responsibility → allow
  if (hasPlanResponsibility(responsibilityName)) return true;

  // Role + action check
  if (user) {
    if (actionName) {
      return hasPermission(user, responsibilityName, actionName);
    }
    return hasResponsibility(user, responsibilityName);
  }

  return false;
}